import pvhApi from '@/api/pvhApi'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Имя',
        isSortable: false
      },
      {
        title: 'Цвет',
        isSortable: false
      },
      {
        title: 'Ручной выбор',
        isSortable: false
      }

    ]
  },
  statuses: [
    {
      id: 1,
      isControlsActive: false,
      isActive: false,
      name: '',
      color: '',
      is_manual: ''
    }
  ],
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  '[pvh] getStatusList': state => state.statuses,
  '[pvh] getStatusListTableHeaders': state => state.tableHeaders,
  '[pvh] getStatusListIsLoading': state => state.isLoading,
  '[pvh] getStatusListSearchValue': state => state.searchValue,
  '[pvh] getStatusListFilter': state => state.filter,
  '[pvh] getStatusListPagination': state => state.pagination,
  '[pvh] getStatusListResponseModal': state => state.responseModal,
  '[pvh] getStatusListResponseModalWithTreaties': state => state.responseModalWithTreaties,
  '[pvh] getStatusListActiveDelete': state => state.isActiveDelete
}

const mutations = {
  '[pvh] GET_STATUS_LIST': (state, statuses) => {
    state.statuses = statuses.data.map(client => {
      return {
        ...client,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  '[pvh] SHOW_STATUS_LIST_MODAL': (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedStatusList = state.statuses
        .filter(client => {
          return client.id === itemId
        })
        .pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedStatusList.name
    }
  },
  '[pvh] SET_STATUS_LIST_ITEM_NAME': (state, value) => {
    state.modal.name = value
  },
  '[pvh] SET_STATUS_LIST_ITEM_VALIDATION': (state, valid) => {
    if (valid.name) {
      state.modal.validation.name.message = valid.name[0]
      state.modal.validation.name.type = 'error'
    }
  },
  '[pvh] CLEAR_STATUS_LIST_MODAL_VALIDATION': (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  },
  '[pvh] CLOSE_STATUS_LIST_MODAL': state => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = {
      id: null,
      message: ''
    }
  },

  // pagination
  '[pvh] SET_STATUS_LIST_PAGINATION': (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    state.pagination.count = Number(headers['x-pagination-total-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  '[pvh] RESET_STATUS_LIST_CURRENT_PAGE': state => {
    state.pagination.currentPage = 1
  },
  '[pvh] SET_CURRENT_PAGE': (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },

  // search
  '[pvh] SET_STATUS_LIST_SEARCH_VALUE': (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  '[pvh] TOGGLE_STATUS_LIST_FILTER': state => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  '[pvh] DELETE_STATUS_LIST_CHECKED_ITEMS_SUCCESS': (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили статус(ы)'
    state.responseModal.type = 'main'
  },
  '[pvh] DELETE_STATUS_LIST_CHECKED_ITEMS_ERROR': (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении статуса произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  '[pvh] DELETE_STATUS_LIST_CHECKED_ITEMS_TREATIES_ERROR': (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные статусы используются:${listNamesErrorItems}`
  },
  '[pvh] CLOSE_DELETE_STATUS_LIST_MODAL': (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  '[pvh] CLOSE_DELETE_STATUS_LIST_MODAL_WITH_TREATIES': (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  '[pvh] TOGGLE_STATUS_LIST_ITEM_ACTIVE': (state, itemId) => {
    const itemsLength = state.statuses.length
    let counter = 0

    state.statuses.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  '[pvh] TOGGLE_STATUS_LIST_ITEM_ACTIVE_ALL': (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.statuses.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  '[pvh] RESET_STATUS_LIST_ALL_CHECKS': (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.statuses.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  // reset store
  '[pvh] RESET_STATUS_LIST_STORE': (state) => {
    // state.searchValue = ''
    state.sort = {}
    // state.filter = {}
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.pagination.currentPage = 1
  }
}

const actions = {
  '[pvh] getStatusList' ({ commit, state }, firstParams = null) {
    let params = {}
    if (firstParams) {
      params = firstParams
    } else {
      params = {
        take: state.pagination.currentTake,
        page: state.pagination.currentPage,
        searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : ''
      }
    }
    pvhApi.getStatusList(params)
      .then(response => {
        commit('[pvh] GET_STATUS_LIST', response.data)
        commit('[pvh] SET_STATUS_LIST_PAGINATION', response.headers)
        state.isLoading = false
      })
      .catch(error => {
        console.log('Ошибка получения списка клиентов', error)
      })
  },

  '[pvh] toggleStatusListItemActive' ({ commit }, itemId) {
    commit('[pvh] TOGGLE_STATUS_LIST_ITEM_ACTIVE', itemId)
  },
  '[pvh] toggleStatusListItemActiveAll' ({ commit }) {
    commit('[pvh] TOGGLE_STATUS_LIST_ITEM_ACTIVE_ALL')
  },
  '[pvh] showStatusListModal' ({ commit }, itemId) {
    commit('[pvh] SHOW_STATUS_LIST_MODAL', itemId)
  },
  '[pvh] setStatusListItemName' ({ commit }, value) {
    commit('[pvh] SET_STATUS_LIST_ITEM_NAME', value)
  },
  '[pvh] clearStatusListModalValidation' ({ commit }, inputName) {
    commit('[pvh] CLEAR_STATUS_LIST_MODAL_VALIDATION', inputName)
  },
  '[pvh] closeStatusListModal' ({ commit }) {
    commit('[pvh] CLOSE_STATUS_LIST_MODAL')
  },
  '[pvh] removeStatusList' ({ commit }, itemId) {
    pvhApi.deleteStatusList(itemId)
      .then(response => {
        this.dispatch('[pvh] getStatusList')
      })
      .catch(error => {
        console.log('Ошибка удаления клиента:' + error)
      })
  },

  // pagination
  '[pvh] getStatusListPage' ({ commit }, pageNum) {
    commit('[pvh] SET_CURRENT_PAGE', pageNum)
    this.dispatch('[pvh] getStatusList')
  },

  // search
  '[pvh] setStatusListSearchValue' ({ commit }, searchValue) {
    commit('[pvh] SET_STATUS_LIST_SEARCH_VALUE', searchValue)
    commit('[pvh] RESET_STATUS_LIST_CURRENT_PAGE')
    this.dispatch('[pvh] getStatusList')
  },

  // delete checked items
  '[pvh] deleteStatusListCheckedItems' ({ commit, state }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []
    state.statuses.forEach((e) => {
      if (e.isActive && e.orders === null) {
        checkedItems.push(e)
      } else if (e.isActive && e.orders.length > 0) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('[pvh] RESET_STATUS_LIST_ALL_CHECKS')
      commit('[pvh] DELETE_STATUS_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await pvhApi.deleteStatusList(item.id).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления клиента', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('[pvh] RESET_STATUS_LIST_ALL_CHECKS')
          commit('[pvh] DELETE_STATUS_LIST_CHECKED_ITEMS_ERROR', errorItems)
          this.dispatch('[pvh] getStatusList')
        } else {
          commit('[pvh] RESET_STATUS_LIST_ALL_CHECKS')
          commit('[pvh] DELETE_STATUS_LIST_CHECKED_ITEMS_SUCCESS')
          this.dispatch('[pvh] getStatusList')
        }
      })
    }
  },
  '[pvh] closeStatusListDeleteModal' ({ commit }) {
    commit('[pvh] CLOSE_DELETE_STATUS_LIST_MODAL')
  },
  '[pvh] closeListDeleteModalWithTreaties' ({ commit }) {
    commit('[pvh] CLOSE_DELETE_STATUS_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
